<div class="search--vehicle">
    <div class="search--input" *ngIf="!aircraft">
        <input class="mvd_form-control autocomplete" id="search" type="text" maxlength="5"
               placeholder="Search by: FAA Number" autocomplete="off"
               [(ngModel)]="faaNumberSearch" [ngModelOptions]="{standalone: true}"
               (keyup.enter)="search()" (onblur)="faaNumberSearchChange()" 
               oninput="this.value = this.value.toUpperCase()" />
        <button class="search__icon" title="Search" type="button" (click)="search()"></button>
    </div>
    <div class="search--omni" [ngClass]="{disabled : readOnly}" *ngIf="aircraft && hasSearched">
        <ul>
            <li>
                <ul class="search--omni__list">
                    <li><b>FAA Number:</b>&nbsp;{{aircraft.faaNumber}}</li>
                    <li><b>Year/Make/Model:</b>&nbsp;{{aircraft.modelYear}} {{aircraft.aircraftMakeDisplayValue}} {{aircraft.aircraftModelDisplayValue}}</li>
                </ul>
            </li>
            <li class="search--omni__remove">
                <a class="icon--remove" title="Remove" href="javascript:void(0)" (click)="removeAircraft()"></a>
            </li>
        </ul>
    </div>
    <button class="icon--add btn--default" type="button" *ngIf="!aircraft && hasSearched" (click)="addAircraft()">Add New Aircraft</button>
</div>